<template>

  <!-- Courses Admin Start -->
  <div class="section overflow-hidden position-relative min-height" id="wrapper">

    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-left-0">
      <div class="container-fluid custom-container">

        <!-- Message Start -->
        <div class="dashboard-head" v-if='user'>
          <div class="message-content">
            <h2>Hello {{user.first_name}}!</h2>
            <h3>Welcome to your COLREGs Dashboard!</h3>
            <p>Navigate your final tests, track your progress, and refine your maritime knowledge—all in one place.</p>
          </div>
        </div>
        <!-- Message End -->

        <!-- Packages Start (Only show for individual users without package) -->
        <div v-if='!user_pkg && isIndividualUser' class="section section-padding mt-n10">
          <div class="container row gx-12">

            <div class="col-lg-12">
            <!-- Section Title Start -->
            <div class="section-title shape-03 ">
              <h3>You are currently on a free trial. Please purchase a package from the options below to continue using our services</h3>
            </div>
            <!-- Section Title End -->

            <div class="row gx-10">
              <div class="col-lg-3">
                <!-- Courses Details Sidebar Start -->
                <div class="sidebar">
                  <!-- Sidebar Widget Information Start -->
                  <div class="sidebar-widget widget-information">
                    <div class="info-price">
                      <span class="price">Free Trial</span>
                      <span class="package-price">£0</span>
                    </div>
                    <div class="info-list">
                      <ul>
                        <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>10</span></li>
                        <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                        <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>No</span></li>
                      </ul>
                    </div>
                    <div class="info-btn">
                      <button class="btn btn-primary btn-hover-dark" disabled>Current Plan</button>
                    </div>
                  </div>
                  <!-- Sidebar Widget Information End -->
                </div>
                <!-- Courses Details Sidebar End -->
              </div>
              <div class="col-lg-3" v-for="pkg in pkgs" :key='pkg._id'>
                <!-- Courses Details Sidebar Start -->
                <div class="sidebar">
                  <!-- Sidebar Widget Information Start -->
                  <div class="sidebar-widget widget-information">
                    <div class="info-price">
                      <span class="price">{{pkg.package_name}}</span>
                      <span class="package-price">£{{pkg.sale_price}}</span>
                    </div>
                    <div class="info-list">
                      <ul>
                        <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>{{pkg.total_questions}}</span></li>
                        <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                        <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>{{pkg.mock_attempts_allowed}}</span></li>
                      </ul>
                    </div>
                    <div class="info-btn">
                      <button class="btn btn-primary btn-hover-dark" style="font-size: 16px;" @click='upgrade(pkg._id)'>Purchase Now</button>
                    </div>
                  </div>
                  <!-- Sidebar Widget Information End -->
                </div>
                <!-- Courses Details Sidebar End -->
              </div>
            </div>
          </div>
          </div>
        </div>
        <!-- Packages End -->

        <!-- Organization Member Message (No package purchase option) -->
        <div v-if='!user_pkg && !isIndividualUser' class="section section-padding mt-n10">
          <div class="container row gx-12">
            <div class="col-lg-12">
              <div class="section-title shape-03">
                <h3>Your organization administrator manages package subscriptions. Please contact them to get access to a package.</h3>
              </div>
            </div>
          </div>
        </div>

        <!-- Your Packages Start -->
        <div class="section section-padding mt-n10 padding-top-50">
          <div class="container row gx-10">

            <div class="col-lg-4" v-if="user_pkg || !isIndividualUser">
              <!-- Courses Details Sidebar Start -->
              <div class="sidebar">
                <!-- Sidebar Widget Information Start -->
                <div class="sidebar-widget widget-information">
                  <div class="info-price">
                    <span class="package-price">Your Selected Package</span>
                    <span class="price" v-if='user_pkg'>{{formatPackageName(user_pkg.pkg_subscribed)}}</span>
                    <span class="price" v-else>Free Trial</span>
                  </div>
                  <div class="info-list" v-if='user_pkg'>
                    <ul>
                      <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>{{ user_pkg.tot_ques}}</span></li>
                      <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                      <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>{{user_pkg.mock_attempts_allowed}}</span></li>
                    </ul>
                  </div>
                  <div class="info-list" v-else>
                    <ul>
                      <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>10</span></li>
                      <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                      <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>No</span></li>
                      <!-- <li><i class="icofont-ui-timer"></i> <strong>Attempts</strong> <span>0</span></li> -->
                    </ul>
                  </div>
                </div>
                <!-- Sidebar Widget Information End -->
              </div>
              <!-- Courses Details Sidebar End -->
            </div>

            <!-- <p v-if='message'>{{message}}</p> -->

            <div :class="(user_pkg || !isIndividualUser) ? 'col-lg-8' : 'col-lg-12'">
              <!-- Courses Resources Start -->
              <div class="courses-resources user-home widget-information">
                <h4 class="title">Here is what all you can do with your account</h4>

                <!-- Resources Wrapper Start -->
                <div class="resources-wrapper">
                  <div class="row row-cols-xl-4 row-cols-md-3 row-cols-2">
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <a @click="gotoTestEnv('practice')" class="cursor-pointer">
                            <img src="/assets/images/resources-icon/icon-1-3.png" alt="Icon">
                            <img class="hover" src="/assets/images/resources-icon/icon-2-3.png" alt="Icon">
                          </a>
                        </div>
                        <h5 class="title cursor-pointer mt-5"><span @click="gotoTestEnv('practice')">Practice Test</span></h5>
                      </div>
                      <!-- Single Resources Start -->

                    </div>
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <a @click="gotoTestEnv('mock')" class="cursor-pointer">
                            <img src="/assets/images/resources-icon/icon-1-4.png" alt="Icon">
                            <img class="hover" src="/assets/images/resources-icon/icon-2-4.png" alt="Icon">
                          </a>
                        </div>
                        <h5 class="title cursor-pointer mt-5"><span @click="gotoTestEnv('mock')">Final Test</span></h5>
                      </div>
                      <!-- Single Resources Start -->

                    </div>
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <router-link to="/dashboard/user/manage-test">
                            <img src="/assets/images/resources-icon/icon-1-1.png" alt="Icon">
                            <img class="hover" src="/assets/images/resources-icon/icon-2-1.png" alt="Icon">
                          </router-link>
                        </div>
                        <h5 class="title"><router-link to="/dashboard/user/manage-test">Test Results</router-link></h5>
                      </div>
                      <!-- Single Resources Start -->

                    </div>
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <router-link to="/dashboard/user/profile">
                            <img src="/assets/images/resources-icon/icon-1-6.png" alt="Icon">
                            <img class="hover" src="/assets/images/resources-icon/icon-2-6.png" alt="Icon">
                          </router-link>
                        </div>
                        <h5 class="title"><router-link to="/dashboard/user/profile">Profile</router-link></h5>
                      </div>
                      <!-- Single Resources Start -->

                    </div>
                  </div>
                </div>
                <!-- Resources Wrapper End -->

              </div>
              <!-- Courses Resources End -->
            </div>


          </div>
        </div>
        <!-- Packages End -->

      </div>
    </div>
    <!-- Page Content Wrapper End -->

    <!-- Free Trial / Package Required Modal -->
    <div v-if="showFreeTrialModal" class="modal-overlay" @click="closeFreeTrialModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Package Required</h3>
          <button class="close-btn" @click="closeFreeTrialModal">&times;</button>
        </div>
        <div class="modal-body">
          <p>You are currently on the free trial. The Final Test is only available once you purchase a package.</p>
          <p>You can still take the Practice Test for free — purchase a package below to unlock the Final Test.</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeFreeTrialModal">Cancel</button>
          <button class="btn btn-primary" @click="goPurchasePackage">View Packages</button>
        </div>
      </div>
    </div>
    <!-- End Free Trial / Package Required Modal -->
  </div>

</template>

<script>
import { jwtDecode } from "jwt-decode";
import { getAllPackageDetails } from '@/services/packageService';
import { getUserPackageDetails } from '@/services/subscriptionService';
import { getUserDetails } from '@/services/userService';

export default {
  name: 'UserDashboard',
  data() {
    return {
      pkgs: [],
      message: null,
      user_pkg: null,
      token_info: null,
      user: null,
      isIndividualUser: true,
      showFreeTrialModal: false
    };
  },

  mounted() {
    const decoded = jwtDecode(localStorage.getItem('access_token'));
    this.token_info = decoded;
    this.getUserDetail();
    this.getUserPackageDetail();
  },

  methods: {

    formatPackageName(name) {
      if (!name) return '';
      // Display only, does not affect the stored value: strip trailing numeric ID suffix (e.g. "hu_package_1783780661126" -> "hu_package")
      return name.replace(/_\d+$/, '');
    },

    async getUserDetail(){
      try {
        this.user = await getUserDetails(this.token_info.email);
        
        // Check if user is part of an organization
        this.isIndividualUser = this.user.org_or_ind === 'individual';
        
        // Only load packages for individual users without subscription
        if (this.isIndividualUser && !this.user_pkg) {
          await this.getPackageAllDetail();
        }
        
        console.log('User details:', this.user);
        console.log('Is individual user:', this.isIndividualUser);
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    },

    async upgrade(pkg_id) {
      // Simply navigate - Checkout.vue handles everything
      this.$router.push(`/checkout/${pkg_id}`);
    },

    async getUserPackageDetail() {
      try {
        const res = await getUserPackageDetails(this.token_info.id);
        this.user_pkg = res.data;
        console.log('User package:', this.user_pkg);
      } catch (error) {
        console.error('Error fetching user package:', error);
        // If 500 error, user might be org member or has no subscription
        // Set user_pkg to null and let the UI handle it
        this.user_pkg = null;
      }
    },

    gotoTestEnv(test_type) {
      const hasActivePackage = !!(this.user_pkg && this.user_pkg.sub_id);

      // Final Test requires a purchased package — free trial users get a
      // popup instead of being allowed into the test.
      if (test_type === 'mock' && !hasActivePackage) {
        this.showFreeTrialModal = true;
        return;
      }

      if (hasActivePackage){
        this.$router.push(`mock-test/${this.user_pkg.sub_id}/${this.token_info.id}/${test_type}`);
      }else{
        this.$router.push(`mock-test/free/${this.token_info.id}/${test_type}`);
      }
    },

    closeFreeTrialModal() {
      this.showFreeTrialModal = false;
    },

    goPurchasePackage() {
      this.showFreeTrialModal = false;
      this.$router.push('/dashboard/user/home');
    },

    async getPackageAllDetail() {
      try {
        const res = await getAllPackageDetails();
        
        // IMPORTANT: Filter out custom packages - only show standard packages to individual members
        // Custom packages have type='custom' OR have an organisation field set
        this.pkgs = res.data.filter(pkg => {
          return pkg.type !== 'custom' && !pkg.organisation;
        });
        
        console.log('All packages from API:', res.data);
        console.log('Filtered packages (standard only):', this.pkgs);
      } catch (error) {
        console.error('Error fetching packages:', error);
      }
    },
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #212832;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  line-height: 1;
  padding: 0;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>